import { render, staticRenderFns } from "./SelectableBodyStyleInput.vue?vue&type=template&id=a8d79c80&"
import script from "./SelectableBodyStyleInput.vue?vue&type=script&lang=js&"
export * from "./SelectableBodyStyleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports